import { initSwipers } from '../utils/functions';

class Testimonies {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => new Section(section));
	}
}

class Section {
	constructor(section) {
		this.section = section;
		this.name = section.querySelector('.testimonies-content__name');
		this.position = section.querySelector('.testimonies-content__position');
		this.description = section.querySelector('.testimonies-content__description');

		this.swiper = initSwipers([section], {
			slideToClickedSlide: true,
			loop: true,
			breakpoints: {
				320: {
					slidesPerView: 'auto',
					centeredSlides: true,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 15,
					centeredSlides: true,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 15,
					centeredSlides: true,
					centeredSlidesBounds: true,
				},
			},
			on: {
				transitionEnd: (swiper) => {
					this.setCurrentSlideContent();
				},
			},
		});
	}

	setCurrentSlideContent() {
		const activeSlideContent = this.getActiveSlideContent();
		this.name.innerHTML = activeSlideContent.name;
		this.position.innerHTML = activeSlideContent.position;
		this.description.innerHTML = activeSlideContent.description;
	}

	getActiveSlideContent() {
		const activeSlide = this.section.querySelector('.swiper-slide-active');

		if (activeSlide) {
			return {
				el: activeSlide,
				name: activeSlide.dataset.name,
				position: activeSlide.dataset.position,
				description: activeSlide.dataset.description,
			};
		}
	}
}

export default Testimonies;
